// extracted by mini-css-extract-plugin
export default {"pageGrid":"MainLayout_pageGrid__XFLP5"};